import BaseService from './base.service'
import { toast } from '@/common/util'
import baseApi from './base.api'
import type { UnitsBasicType } from '@/types/types'

export const unidadesDeNegocioServices = {
  ...baseApi,
  resource: 'unidadeDeNegocio',

  async getListBasic(params?: UnitsBasicType): Promise<{ success: boolean, data: { id: string, nome: string }[] }> {
    try {
      return await unidadesDeNegocioServices.get(`Basic`, { ...params })
    } catch (error) {
      const { notifications }: { notifications: string[] } = error.response?.data || {}
      toast.error({ message: notifications[0] || 'Erro ao buscar lista de unidades!' })
    }
  }
}

class UnidadesDeNegocioService extends BaseService {
  constructor() {
    super({ resource: 'unidadeDeNegocio' })
  }
}

const unidadesDeNegocioService = new UnidadesDeNegocioService()

export default unidadesDeNegocioService